<div class="container">
            <div id="cylinderchart" ></div>
    <!-- <div class="col-1">
        <ngx-slider style="margin-left: -20px" [(value)]="options.chart.options3d.alpha" (userChange)="rotateChart($event)"
            [options]="verticalSliderOptions"></ngx-slider>
    </div> -->
</div>
<!-- <ngx-slider [(value)]="options.chart.options3d.beta" (userChange)="rotateChart(null, $event)" [options]="sliderOptions"></ngx-slider> -->